import { render } from "./archive-form-row.vue?vue&type=template&id=5cf0cd68&scoped=true"
import script from "./archive-form-row.vue?vue&type=script&lang=js"
export * from "./archive-form-row.vue?vue&type=script&lang=js"

import "./archive-form-row.vue?vue&type=style&index=0&id=5cf0cd68&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf0cd68"],['__file',"src/components/notepad/archives/archive-form-row.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5cf0cd68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5cf0cd68', __exports__)) {
    api.reload('5cf0cd68', __exports__)
  }
  
  module.hot.accept("./archive-form-row.vue?vue&type=template&id=5cf0cd68&scoped=true", () => {
    api.rerender('5cf0cd68', render)
  })

}


export default __exports__